export default defineAppConfig({
  name: 'Envelope',
});
